// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"ModalOptionsConfirmation_modal_content__B8HoO"};